module.exports = __webpack_public_path__ + "img/2.0091e4ac.png";